<div (click)="goToRichieste()" class="d-flex align-items-center hover"> 
    <div class="flex-shrink-0">
        <div class="avtar avtar-s border" *ngIf="item.sequenza=='sequenziamento'" style="background-color: #3ec9d6;color:white">S</div>
        <div class="avtar avtar-s border" *ngIf="item.sequenza=='cariotipo'" style="background-color: #2ca87f;color:white">C</div>

    </div>
    <div class="flex-grow-1 ms-3">
        <div class="row g-1">
            <div class="col-6">
                <h6 class="mb-0">Richiesta {{item.sequenza}}</h6>
                <p class="text-muted mb-0"><small>{{item.maxdata | date: 'dd/MM/yyyy HH:mm'}}</small></p>
            </div>
            <div class="col-6 text-end">
                <div class="mb-1">
                    <p-badge *ngIf="item.Stati.value=='completata'" [value]="item.Stati.value | titlecase" severity="success" />
                    <p-badge *ngIf="item.Stati.value=='lavorazione'" [value]="item.Stati.value | titlecase" severity="warning" />
                    <p-badge *ngIf="item.Stati.value=='inviata'" [value]="item.Stati.value | titlecase" />
                </div>
            </div>
        </div>
    </div>
</div>